<template>
  <v-dialog
    v-model="value"
    :max-width="maxWidth"
    :persistent="true"
    class="base-modal-viewer"
  >
    <v-card class="content">
      <v-card-title class="headline d-flex justify-space-between w-100">
        <div class="form-section-base__title">
          <slot name="title"></slot>
        </div>
      </v-card-title>
      <v-card-text>
        <slot name="body"></slot>
      </v-card-text>
      <v-divider v-if="divider"></v-divider>
      <v-card-actions class="footer">
        <v-spacer></v-spacer>
        <slot name="buttons"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseModalView',
  props: {
    value: Boolean,
    divider: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: '560px',
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  methods: {
    onCancel() {
      this.$emit('onCancel');
    },
    onOk() {
      this.$emit('onOk');
    },
  },
};
</script>

<style scoped lang="scss">
.base-modal-viewer {
  padding-bottom: 25px;
  overflow-x: hidden !important;
}
.title {
  font-family: 'Helvetica', sans-serif !important;
  color: $color-base;
}

.content {
  padding-bottom: 25px;
  background-color: white;
}

.footer {
  padding: 0 24px 20px;
}
</style>
